// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyA2nE5hV5Y5nJS8QbloJn1EJAJF4xnNk3w",
  authDomain: "clonedb-75f90.firebaseapp.com",
  databaseURL: "https://clonedb-75f90.firebaseio.com",
  projectId: "clonedb-75f90",
  storageBucket: "clonedb-75f90.appspot.com",
  messagingSenderId: "11357726453",
  appId: "1:11357726453:web:782f55045e066cb5e047bc",
  measurementId: "G-LD5WYPGJSN"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebase.auth();

export { db,auth };